import { Injectable } from '@angular/core';

import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { Token } from '../manager/token';
// import 'rxjs/Rx';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DataUploadService {
  TokenCls;
  constructor(private http: HttpClient, private router: Router) {
    this.TokenCls = new Token(this.router);
  }

  InventoryDataUpload(dataobj): any {
    return this.http.post(environment.FileApiUrl + '/api/inventory-data-upload', dataobj);
  }
  iAgentProDataUpload(dataobj): any {
    return this.http.post(environment.ApiUrl + '/api/Upload_CBF_Inventory', dataobj);
  }

  downloadInventoryTemplate(id):any {
    //  api/inventory-data-upload-download-template/client/{id}
    return this.http.get(environment.ApiUrl + '/api/inventory-data-upload-download-template/client/' + id).pipe(map(res => res));
  }

  getModuleList(client_id):any {
    return this.http.get(environment.ApiUrl + `/api/PNP_Module_Name/${client_id}`).pipe(map(res => res));
  }
  getEmployeeList(id):any {
    return this.http.get(environment.ApiUrl + `/api/PNP-Inventory-Data-Employee/client/${id}`).pipe(map(res => res));
  }

  // PNP-inventory-data-upload

  projectAndPriorityUpload(formBody):any {
    return this.http.post(environment.FileApiUrl + '/api/PNP-inventory-data-upload', formBody);
  }

  // get uploaded files status
  getFileStatus(client_id){
    return this.http.get(environment.ApiUrl + `/api/file-status/Get/${client_id}`).pipe(map(res => res));
  }
  CiiNRADataUpload(dataobj){
    return this.http.post(environment.ApiUrl + '/api/ciinra-inventory-upload', dataobj);
  }

  downloadCiiNRATemplate():any {
    return this.http.get(environment.ApiUrl + '/api/ciinra_download_template',  { responseType: 'blob'})
      .pipe(map(res => {
        return {
          filename: 'CiiNRATemplate.xlsx',
          data: res
        };
      }))
  }

  downloadiAgentProTemplate(client_id):any {
      return this.http.get(environment.ApiUrl + '/api//CBF_Template_Download/client/' + client_id).pipe(map(res => res));
  }
}
